import React, { useContext } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { PageStatus } from "../../types";
import { AppContext } from "../context";

import useUrlState from "@ahooksjs/use-url-state";
import GlobalControl from "@/components/GlobalControl";
import GlobalFooter from "@/components/GlobalFooter";

import usePageTracking from "@/utils/usePageTracking";
import Part1 from "./Part1";
import Part2 from "./Part2";
import Part3 from "./Part3";
import Part4 from "./Part4";
import Part5 from "./Part5";
import Part6 from "./Part6";
import Part7 from "./Part7";
import Part8 from "./Part8";
import Part9 from "./Part9";
import Part10 from "./Part10";
import { Mousewheel, Virtual } from "swiper";

let _time: NodeJS.Timeout | null = null;

const Content: React.FC = () => {
  const { state: nftData } = useContext(AppContext);
  const p = useUrlState();
  usePageTracking();

  const INIT_PAGE_STATUS: PageStatus[] = [
    {
      pageNum: 0,
      status: "fade_in",
      component: Part1,
      show: !!nftData.user.address,
    },
    { pageNum: 1, status: "none", component: Part2, show: !!nftData.buy_count },
    { pageNum: 2, status: "none", component: Part3, show: !!nftData.nft_value },
    {
      pageNum: 3,
      status: "none",
      component: Part4,
      show: !!nftData.top_profit,
    },
    {
      pageNum: 4,
      status: "none",
      component: Part5,
      show: !!nftData.paper_hand,
    },
    {
      pageNum: 5,
      status: "none",
      component: Part6,
      show: !!nftData.most_expensive,
    },
    { pageNum: 6, status: "none", component: Part7, show: !!nftData.long_hold },
    { pageNum: 7, status: "none", component: Part8, show: !!nftData.less_hold },
    { pageNum: 8, status: "none", component: Part9, show: !!nftData.top_hold },
    { pageNum: 9, status: "none", component: Part10, show: true },
  ];

  const [page, setPage] = React.useState<number>(0);
  const [show_finger, setShowFinger] = React.useState<boolean>(false);

  const [pageStatus, setStatus] = React.useState<PageStatus[]>(
    INIT_PAGE_STATUS.filter((v) => v.show).map((v, index) => ({
      ...v,
      pageNum: index,
    }))
  );

  React.useEffect(() => {
    document.title = "2022 NFT Glory Moments";
    if (p[0].isShare) {
      setShowFinger(false);
    }
    if (_time) {
      return setShowFinger(false);
    }
    _time = setTimeout(() => {
      setShowFinger(true);
    }, 10000);

  }, [p]);

  const updateStatus = (activeIndex: number) => {
    if (_time) {
      clearTimeout(_time);
    }

    _time = setTimeout(() => {
      setShowFinger(true);
    }, 10000);

    if (activeIndex === pageStatus.length - 1) {
      setShowFinger(false);
      clearTimeout(_time);
    }

    setShowFinger(false);
    const status: PageStatus[] = pageStatus.map((item) => {
      if (item.pageNum === page) {
        return { ...item, ...{ status: "fade_out" } };
      }
      if (item.pageNum === activeIndex) {
        return { ...item, ...{ status: "fade_in" } };
      }
      return { ...item, ...{ status: "none" } };
    });
    setPage(activeIndex);
    setStatus(status);
  };

  return (
    <>
      <GlobalControl />
      <GlobalFooter />
      <Swiper
        modules={[Virtual, Mousewheel]}
        mousewheel={{
          sensitivity: 1200,
          thresholdTime: 1200,
        }}
        direction="vertical"
        style={{ height: "100%" }}
        onSlideChange={(e) => updateStatus(e.activeIndex)}
      >
        {pageStatus.map(({ component: Component, status, pageNum }, index) => {
          return (
            <SwiperSlide key={pageNum}>
              <Component type={status} data={nftData} />
            </SwiperSlide>
          );
        })}
      </Swiper>

      {show_finger && <div className="finger_tip" />}
    </>
  );
};

export default Content;
